// For Service Workflow
import { useNuxtApp } from '#app';
import { BaseService } from '../base/base.service';
import type { IModelResponse } from '../base/dto/base.dto';
import { ModelGETWorkflowRuntime, ModelGETWorkflowRuntimeId, type IModelGETWorkflowRuntimeRequest, type IModelGETWorkflowRuntimeResponse, type IModelPOSTWorkflowRuntimeRequest, type IModelPUTWorkflowRuntimeRequest } from './dto/workflow.dto';
import { WorkflowRepository } from './workflow.repository';

export class WorkflowService extends BaseService {
  private workflowRuntimeRepository = new WorkflowRepository(this.api, this.configService);

  async getWorkflowRuntime(params: IModelGETWorkflowRuntimeRequest): Promise<ModelGETWorkflowRuntime[]> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelGETWorkflowRuntime[] = []

    try {
      const res = await this.workflowRuntimeRepository.getWorkflowRuntime(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map((e: IModelGETWorkflowRuntimeResponse) => new ModelGETWorkflowRuntime(e))
        console.log('getWorkflowRuntime', params, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, WorkflowService.name);
    }
    return dataResult;
  }

  async getWorkflowRuntimeId(id: string | number): Promise<ModelGETWorkflowRuntimeId> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelGETWorkflowRuntimeId = new ModelGETWorkflowRuntimeId();
    try {
      const res = await this.workflowRuntimeRepository.getWorkflowRuntimeId(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETWorkflowRuntimeId(resData.data);
        console.log('getWorkflowRuntimeId', {}, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, WorkflowService.name);
    }
    return dataResult;
  }
}
